import type { MaterialSelectorCartItem, MaterialSelectorMaterial, MaterialSelectorOption } from '../interfaces';
import { getSizeValues } from '../../utils/sizeOptions';
import { getVariantStockQuantity, isVariantAvailable } from '../../utils/variantInventory';
import { getFirstValidSizeForMaterial } from '../../utils/cartValidation';

export const getMaterialToneClass = (materialName = '', hasIcon = false) => {
  if (hasIcon) return '';

  const normalized = materialName.toLowerCase();

  if (normalized.includes('white') || normalized.includes('rose')) return '';
  if (normalized.includes('gold')) return 'material-option--gold';

  return '';
};

export const normalizeMaterials = (
  materials?: MaterialSelectorMaterial[]
): MaterialSelectorOption[] | null => {
  if (!materials?.length) return null;

  return materials.map((material) => {
    if ('name' in material && 'image' in material) {
      return {
        materialName: material.name,
        materialIcon: {
          icon: material.image,
        },
      };
    }

    return material as MaterialSelectorOption;
  });
};

export const getSelectedMaterialName = (
  value: string | undefined,
  storeValue: string,
  materialPrices: MaterialSelectorOption[],
  shouldUseStoreValue: boolean
) => {
  if (shouldUseStoreValue && !value) {
    return storeValue || materialPrices[0]?.materialName || '';
  }

  return value || materialPrices[0]?.materialName || '';
};

export const getMaterialOptionState = (
  material: MaterialSelectorOption,
  selectedMaterial: string,
  cartItem?: MaterialSelectorCartItem,
  productId?: string,
  itemId?: string
) => {
  const iconUrl = material.materialIcon?.icon?.publicUrl || '';
  const variantProductId = cartItem?.product.id || productId || itemId;
  const materialSizes = getSizeValues(material.sizes);
  const firstValidSize = materialSizes.length
    ? getFirstValidSizeForMaterial({
      material,
      productSizes: cartItem?.product.sizes || [],
      productId: variantProductId,
      quantity: cartItem?.quantity || 1,
    })
    : '';
  const noSizeStockQuantity = getVariantStockQuantity(material, '', variantProductId);
  const disabledByInventory = materialSizes.length
    ? !firstValidSize
    : noSizeStockQuantity === 0 || !isVariantAvailable(material, '', variantProductId);

  return {
    iconUrl,
    isSelected: selectedMaterial === material.materialName,
    disabledByInventory,
    toneClass: getMaterialToneClass(material.materialName, Boolean(iconUrl)),
  };
};
